interface IFormTitle {
    title: string,
    alignLeft?: boolean,
}

/**
 * Common form title.
 */
const FormTitle = (props: IFormTitle) => {

    return (
        <div className={`flex ${ props.alignLeft ? '' : 'justify-center text-center' }`}>
            <h1 className="text-2xl text-center font-bold text-gray-700 mb-8">{ props.title }</h1>
        </div>
    )
};

export default FormTitle;